const MODAL_PLACEMENT = {
  CENTER: "center",
  BOTTOM: "bottom"
};
const MODAL_MOBILE_OFFSET = 60;
export {
  MODAL_MOBILE_OFFSET,
  MODAL_PLACEMENT
};
//# sourceMappingURL=modal.es.js.map
